import { Upload } from "antd";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { InboxOutlined } from '@ant-design/icons';
import { URL } from "../../../../../../../service/api";

const { Dragger } = Upload;

export function UploadDoc({ carregarDocumentosExistents, setFileId, isTaskId, formulario }) {
    
  const props = {
    name: "file",
    multiple: false,
    accept: ".pdf",
    action: `${URL}/obrigacao/arquivo/upload?id=${isTaskId}`,
    method: "post",

    beforeUpload: async (file) => {
      const isPdf = file.type === "application/pdf";
      if (!isPdf) {
        toast.error("Você pode apenas fazer upload de arquivos PDF!");
        return Upload.LIST_IGNORE;
      }

      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        toast.error("O arquivo deve ser menor que 5MB!");
        return Upload.LIST_IGNORE;
      }

      const formatoValido = /^\d{2}\/\d{4}$/; // Expressão regular pra validar MM/YYYY
      if (
        !formatoValido.test(dayjs(formulario.dataReferencia).format("MM/YYYY"))
      ) {
        toast.error(
          "A data de competência da obrigação " +
            dayjs(formulario.dataReferencia).format("MM/YYYY") +
            " não está no formato MM/YYYY esperado."
        );
        return Upload.LIST_IGNORE;
      }

      return true;
    },
    onChange: async (info) => {
      if (info.file.status === "done") {
        const { response } = info.file;

        try {
          setFileId("");
          await carregarDocumentosExistents(isTaskId);
          toast.success("Documento importado e lista atualizada com sucesso!");
        } catch (error) {
          console.error("Erro ao carregar documentos existentes:", error);
          toast.error("Erro ao atualizar a lista de documentos.");
        }

        if (response && response.id) {
          const fileId = response.id;
          setFileId(fileId);
        }
      } else if (info.file.status === "error") {
        toast.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  return (
    <>
      <Dragger {...props}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Clique ou arraste o arquivo para esta área para fazer upload
        </p>
        <p className="ant-upload-hint">
          Apenas arquivos PDF com tamanho máximo de 5MB são permitidos.
        </p>
      </Dragger>
    </>
  );
}

export default UploadDoc;
